import React, { useEffect, useState } from "react";
import { pxToRem } from "../../../utilities/uiUtils";
import GlobalAccountSearch from "./GlobalAccountSearch";
import { useSearchParams, useLocation, useParams } from "react-router-dom";
import SavedGlobalContacts from "../GlobalContacts/SavedGlobalContacts";
import GenericTabs from "../genericComponents/GenericTabs";
import { fetchGlobalAccountsIndustriesDropDown } from "../../../services/authService";
import { dbGet, dbSet } from "../../../utilities/db";
import SavedGlobalAccounts from "./SavedGlobalAccounts";
import { useUser } from "../../../context/UserContext";
import { getUrlDetailsObj, getUserStatsObject, recordActivity } from "../../../services/commonService";
import { deleteUserGlobalAccountsListByName, getUserGlobalAccountsNameList } from "../../../services/iqApiV2";
import { useBanner } from "../../../context/BannerContext";

function GlobalAccountWrapper() {
  const [searchParams, setSearchParams] = useSearchParams();
  const defaultTab = "global_accounts_tabs";
  const activeTabFromUrl = searchParams.get("tab") || defaultTab;
  const activeSubTabFromUrl = searchParams.get("subTab"); // Get subTab for logging
  const [activeParentTabKey, setParentActiveTab] = useState(activeTabFromUrl);

  const { user } = useUser();
  const location = useLocation();
  const pageParsedData = getUrlDetailsObj(useLocation, useParams);
  const [tabs, setTabs] = useState([]);
  const showBanner = useBanner();

  const fetchAndSetAccountListName = async() => {
    let accountLists = await getUserGlobalAccountsNameList(user?.id)
    console.log("accountLists : ", accountLists)
    setTabs(accountLists || [])
  }
  
  useEffect(() => {
      if(user?.id){
        fetchAndSetAccountListName();
      }
  }, [user?.id])

  useEffect(() => {
    async function fetchDropdowns() {
      // ... (Dropdown fetching logic remains the same)
      const DOWNLOADS = [];

      const KEYS = [
        { key: "industriesDropdown", apiParam: undefined },
        { key: "regionDropdown", apiParam: "region" },
        { key: "countryDropdown", apiParam: "country" },
      ];

      for (const d of KEYS) {
        const cached = await dbGet(d.key);

        if (!(Array.isArray(cached) && cached.length)) {
          DOWNLOADS.push(d);
        }
      }

      if (DOWNLOADS.length === 0) return;

      await Promise.all(
        DOWNLOADS.map(async ({ key, apiParam }) => {
          const resp = await fetchGlobalAccountsIndustriesDropDown(apiParam);
          const formatted = (resp || [])
            .filter(item => typeof item === "string" && /[a-zA-Z]/.test(item))
            .map(s => ({ id: s, value: s, label: s }));

          await dbSet(key, formatted);
          console.log(`📦 Fetched & stored ${formatted.length} → ${key}`);
        })
      );
    }

    fetchDropdowns();
  }, []);


  // --- FIX 1: Logging on Mount/Refresh (Independent of default setting) ---
  useEffect(() => {
    // 1. Guard check: Ensure user is logged in
    if (!user?.id || activeParentTabKey !== defaultTab) {
      return;
    }
    
    // 2. Map sub-tab to the desired log name
    const tabTypeMap = {
      "find_global_accounts": "Find Accounts",
      "saved_global_accounts": "Saved Global Accounts",
    };
    
    const pageName = tabTypeMap[activeSubTabFromUrl];

    // 3. Only log if we are on one of the tracked sub-tabs
    if (pageName) {
      const actionType = "page_load";
      const dataDetails = `Page Load: ${pageName}`;
      const contextualId = user.id;

      const userStat = getUserStatsObject(
          pageName, 
          actionType,
          dataDetails,
          window.location.href, 
          contextualId
      );
      
      pageParsedData.query_params = { 
          tab: activeParentTabKey,
          subTab: activeSubTabFromUrl 
      };
      userStat.url_details = pageParsedData;

      recordActivity(userStat);
    }

  }, [activeParentTabKey, activeSubTabFromUrl, user?.id, location.pathname]);
  // --- END LOGGING FIX ---

  // --- FIX 2: Removed Logging from setTimeout to prevent duplication on switch ---
  useEffect(() => {
    const subTab = searchParams.get("subTab");
    
    // Check if subTab is missing AND we are on the main tab
    if (!subTab) { 
      
      const debounceTimer = setTimeout(() => {
        // 1. Set the default subTab in the URL
        setSearchParams({
          tab: activeParentTabKey,
          subTab: "find_global_accounts",
        });

        // Logging call removed from here to prevent duplicate firing on navigation switch

      }, 100);
      return () => clearTimeout(debounceTimer);
    }
  }, [activeParentTabKey, setSearchParams, searchParams]);

  const handleUpdateList = async () => {
   fetchAndSetAccountListName()
  }

  const handleDeleteList = async (name) => {

      try {
        await deleteUserGlobalAccountsListByName({name: name, user_id: user?.id});
        showBanner({
          message: "List Deleted!",
          title: "Alert",
          type: "success",
          duration: 1000,
        });
      } catch (error) {
        showBanner({
          message: "List Deletion failed!",
          title: "Alert",
          type: "error",
          duration: 1000,
        });
      } finally {
        setTabs((prev) => prev.filter((l) => l.name !== name));
      }
  };
  

  const tabData = [
    {
      tabId: "find_global_accounts",
      label: "Find Accounts",
      comp: <GlobalAccountSearch handleUpdateList={handleUpdateList} />,
    },
    { // <--- NEW TAB ENTRY
      tabId: "saved_global_accounts",
      label: "Saved Accounts",
      comp: <SavedGlobalAccounts tabs={tabs} handleDeleteList={handleDeleteList} />,
    },
    // {
    //   tabId: "saved_global_contacts",
    //   label: "Saved Accounts",
    //   comp: <SavedGlobalContacts />,
    // },
  ];

  return (
    <div
      style={{
        backgroundColor: "#fff",
        // height: pxToRem(1080),
        borderRadius: pxToRem(10),
        padding: pxToRem(10),
      }}
    >
      <GenericTabs tabs={tabData} />
    </div>
  );
}

export default GlobalAccountWrapper;